import axios from "axios";

export const GUEST_TOKEN = "b6d18755-3766-4487-9029-b540ae24d054";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const userToken = localStorage.getItem("user_token");

  // ✅ AUTH HEADER
  if (userToken) {
    config.headers?.set("Authorization", `token ${userToken}`);
  } else {
    config.headers?.set("GUEST-AUTH-TOKEN", GUEST_TOKEN);
  }

  // 🔥 FORM DATA VS JSON (CRITICAL FIX)
  if (config.data instanceof FormData) {
    // ❌ let browser set multipart boundary
    config.headers?.delete("Content-Type");
  } else {
    // ✅ normal JSON requests
    config.headers?.set("Content-Type", "application/json");
  }

  return config;
});

export default api;
